// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1__f83fc4560146421b9738","cls2":"ContentFeedback-cls2__d8e48c38db5774051305 ContentFeedback-cls1__f83fc4560146421b9738"};